import Backbone from 'backbone';

import Modal from '../view/modal';
import PickModal from '../view/pick.modal';
import View from '../view/view';

import { handle } from '../service/messages';
import { error } from '../ui/messages';
import { promisify } from '../utils/promisify';
import { hashify } from './arrays';



export { ask, pick, }



// todo @test, @accept
function pick(selected, { collection, cluster, clusters, idOnly = true, fullCollection = false }) {
    if (typeof collection === 'function')
        collection = collection();

    const hash = hashify( collection, item => [item.id, item] );
    
    const view = PickModal.of( collection, clusters, cluster );
    const binding = view.bind( { selected, } )
        .then( view => view.focus() );

    binding.view = view;

    return ask( binding, 
        'popups::pick - title', 'actions::choose', 'actions::cancel',
        { medium: true } )
        
        .then( () => fullCollection || view.model.get( 'selected' ).length < collection.length
            ? view.model.get( 'selected' )
            : [] )
        .then( selected => idOnly 
            ? selected.map( el => el.id ? el.id : el )
            : selected.map( el => hash[el.id] ) );
}

const stack = [];

function ask(possiblyViewRendering, title, accept, cancel, options = {}, callback) {
    if (!callback && typeof options === 'function')
        callback = options,
        options = {};
    if (options.disable === undefined)
        options.disable = true;
    const { warning, } = options;

    const [focused] = Backbone.$( ':focus' );
    if (focused)
        focused.blur();

    // fix scrollbars
    Backbone.$( 'body' ).addClass( 'tl-modal-open' );
    hideTopmost();

    // console.log( 'ask - after hideTopmost' );

    const modal = new Modal( options );
    stack.push( {
        focused,
        modal,
        rendering: promisify( possiblyViewRendering )
    } );

    promisify( possiblyViewRendering )
        .then( view => {
            if (view instanceof View)
                modal.listenToOnce( view, 'modal:accept', 
                    result => modal.trigger( 'ok', result ) );
        } );

    const text = 'string' === typeof possiblyViewRendering ? possiblyViewRendering : undefined;
    modal.render( { title, accept, cancel, text, warning } )
        // .then( () => console.log( 'modal render done' ) ) 
        .then( () => promisify( possiblyViewRendering ) )
        .then( () => {
            if (topmost().modal === modal)
                openTopmost();
        } );

    return promisify( possiblyViewRendering )
        .then( view => onOpen( modal, view, callback ) );
}

function topmost() {
    return [...stack].reverse()[0];
}

function openTopmost() {
    if (!stack.length) return;

    // console.log( 'openTopmost call - there is something!' );

    const { modal, rendering, focused } = topmost();
    modal.listenTo( modal, 'hide', popTopmost );
    modal.listenTo( modal, 'hidden', () => {
        modal.remove();
        Backbone.$( focused ).focus();
    } );
    rendering.then( view => modal.open( view ) );
}

function hideTopmost() {
    // console.log( 'hideTopmost call' );
    if (!stack.length)
        return;

    // console.log( `stack.length == ${stack.length}` );
    topmost().modal.stopListening( topmost().modal, 'hide' );
    topmost().modal.stopListening( topmost().modal, 'hidden' );
    topmost().modal.close();
}

function popTopmost() {
    stack.pop();
    // console.log( `popTopmost call, stack length after pop = ${stack.length}` );
    if (stack.length)
        return openTopmost();

    // all modals closed; finish
    // todo: after 150ms
    Backbone.$( 'body' ).removeClass( 'tl-modal-open' );
}
    
function onOpen(modal, form, callback = () => true) {
    let resolve, reject;
    const result = new Promise( (rs, rj) => (resolve = rs, reject = rj) );

    if (modal.options.onOpen)
        modal.options.onOpen( {
            reject: () => modal.$( '.action-reject' ).click()
        } );

    modal.on( 'reject', reject ); 

    // todo: call reject() when modal is just closed
    // todo: disable "save" button when no data changed
    modal.on( 'ok', clickResult => {
        // disable controls and "save" button
        if (modal.options.disable)
            disable();

        // result will be undefined if no callback passed
        let result = callback && callback( form, clickResult, modal );
        
        // operation returns nothing and thus
        // allows us to close the window
        if (undefined === result)
            return modal.close(), resolve();
            
        // operation returns "true" and thus
        // allows us to close the window
        if (true === result)
            return modal.close(), resolve();

        // operation doesn't allow to close
        // the window but we must enable all 
        // the controls
        if (false === result) 
            return undoDisable();
        
        // operation is async
        // todo: assert Promise
         
        // after finish of the operation
        // enable all the controls (and restore focus)
        if (result.done)
            return result.done( result => {
                    modal.close(); undoDisable();
                    // pass result of callback function back of ask()
                    resolve( promisify( result ) );
                } )
                // todo: show message near the input
                // if error, show it
                // [message, field] or { message, field }
                .fail( message => handle( modal, error( message ) ) )
                // and enable all the controls
                .fail( undoDisable );

        return promisify( result )
                .then( result => {
                    modal.close(); undoDisable();
                    resolve( result );
                } )
                .catch( message => {
                    handle( modal, error( message ) );
                    undoDisable();
                } );

        function undoDisable() {
            if (modal.options.disable)
                enable();
        }
    } );

    return result;
    
    function enable() {
        form.enable && form.enable( { restoreFocus: true } );
        modal.enable();
    }
    
    function disable() {
        form.disable && form.disable();
        modal.disable();
    }
    
};


// WEBPACK FOOTER //
// ./src/js/utils/popups.js